module.exports = __webpack_public_path__ + "media/img/pages/companies/bcv-664865e20b042a9099f348e4de0ce904.png";